// @flow

import type {Error} from 'redux/v1/customer/put/models';

export type PreparedErrors = {
  [fieldName: string]: string,
};

export const parseErrors = (errors: Error[]): PreparedErrors =>
  errors?.reduce((error, {relate, message}) => {
    return {...error, [relate]: message};
  }, {});
